<template>
  <v-dialog persistent :value="dialog.status" max-width="290">
    <v-card>
      <v-card-title v-if="dialog.title" class="headline">
        {{ dialog.title }}
      </v-card-title>

      <v-card-text v-if="dialog.message">
        {{ dialog.message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="toggleDialog({ status: false })"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters(['dialog']),
  methods: mapActions(['toggleDialog'])
}
</script>

<style></style>
